import React from 'react';
import PainelUltimos5DiasBorerControl from './PainelUltimos5DiasBorerControl';
import PainelAcompanhamentoBorerControl from './PainelAcompanhamentoBorerControl';

function ObservabilidadeBorerControl() {
  return (
    <div>
      <PainelUltimos5DiasBorerControl />
      <PainelAcompanhamentoBorerControl />
    </div>
  );
}

export default ObservabilidadeBorerControl;
